import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MilestoneProgress } from "./MilestoneProgress/MilestoneProgress";
import { useDispatch, useSelector } from "../../../hooks";
import { ChallengeCategory, IChallenge } from "../../../redux/challenges";
import styles from './ChallengeDetail.module.scss';
import { Loader } from "../../../components/Loader/Loader";
import { ErrorSnackbar } from "../../../components/ErrorSnackbar/ErrorSnackbar";
import { ThinButton } from "../../../components/Buttons/ThinButton/ThinButton";
import { AppContext } from "../../../components/Menu/MenuButton";
import { RatingType } from "../../../redux/ratings/get-ratings.handler";
import { AssetsContext } from "../../AssetsPage/AssetsTypes";
import { setCurrentRating } from "../../../redux/ratings";
import { Button } from "../../../components/Buttons/Button/Button";
import { ChallengeTimeLeftBlock } from "./ChallengeTimeLeftBlock";
import { challengesData, IChallengeView } from "../ChallengesList/challenges";
import { ChallengeTotalReward } from "../ChallengeTotalReward/ChallengeTotalReward";

export const ChallengeDetail = () => {
    const [challenge, setChallenge] = useState<IChallenge | undefined>(undefined);
    const [viewData, setViewData] = useState<IChallengeView | undefined>(undefined);
    const { type } = useParams() ?? "0";
    const { items: challenges, loading, error } = useSelector(store => store.challenges);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!challenge)
            return;

        setViewData(challengesData.find(data => data.id === challenge.type));
    }, [challenge]);

    const openRating = () => {
        dispatch(setCurrentRating(RatingType.SubscriptionRewardChallenge));
        navigate(`/${AppContext.Assets}/${AssetsContext.Ratings}`);
    }

    const getProgress = () => {
        if (!challenge || (challenge.milestones.length === 1 && challenge.milestones[0].threshold === 1))
            return;

        return <div className={styles.line}>
            <span>Прогресс: </span>
            { viewData && (
                    challenge.milestones.length === 1
                        ? <viewData.progress progress={ challenge.progress } total={ challenge.milestones[0].threshold } />
                        : <viewData.progress
                            progress={ challenge.progress }
                            total={ challenge.milestones[challenge.milestones.length - 1].threshold }
                            label={ viewData.progressLabel }
                        />
                )
            }
        </div>
    }

    const getRewardProgress = () => {
        if (!challenge)
            return;

        if (challenge.milestones.length > 1 )
            return <MilestoneProgress { ...challenge } />;

        return (
            <div className={styles.simpleRewardCont}>
                <span className={styles.labelText}>
                    Награда:
                </span>
                <ChallengeTotalReward milestones={challenge.milestones} />
            </div>
        );
    }

    useEffect(() => {
        if (!type || challenges.length === 0) return;

        const foundChallenge = challenges.find(item => item.type === +type);
        setChallenge(foundChallenge);
    }, [type, challenges]);

    const getInfo = () => {
        const progress = getProgress();
        if (progress || challenge?.finishDate) {
            return (
                <div className={styles.info} >
                    { getProgress() }
                    { challenge && challenge.finishDate > 0 && <ChallengeTimeLeftBlock finishDate={challenge.finishDate} /> }
                </div>
            );
        }
    }

    return (
        <> { challenge &&
                <div className={styles.container} >
                    <div className={styles.title}>{ challenge.name }</div>                    
                    { getInfo() }
                    { viewData && viewData.cardDescription }
                    { getRewardProgress() }
                    { challenge.category === ChallengeCategory.Periodical && <ThinButton caption="Рейтинг" handler={() => openRating() } /> }
                    <Button caption='Закрыть' type='orange' handler={ () => window.history.back() } />
                </div>
            }

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}